import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { NgbActiveModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { EventManager, AlertService, JhiLanguageService } from 'ng-jhipster';

import { UnavailableDate } from './unavailable-date.model';
import { UnavailableDatePopupService } from './unavailable-date-popup.service';
import { UnavailableDateService } from './unavailable-date.service';
import { School, SchoolService } from '../school';
import { Principal } from '../../shared/index';
import { AbstractDialogComponent } from '../abstract-dialog-component/abstract-dialog.component';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
    selector: 'jhi-unavailable-date-dialog',
    templateUrl: './unavailable-date-dialog.component.html'
})
export class UnavailableDateDialogComponent extends AbstractDialogComponent implements OnInit {

    unavailableDate: UnavailableDate;
    authorities: any[];
    isSaving: boolean;
    lessonsAction: string;

    constructor(
        public activeModal: NgbActiveModal,
        private jhiLanguageService: JhiLanguageService,
        alertService: AlertService,
        private unavailableDateService: UnavailableDateService,
        schoolService: SchoolService,
        private eventManager: EventManager,
        principal: Principal
    ) {
        super(schoolService, alertService, principal);
        this.jhiLanguageService.setLocations(['unavailableDate', 'schoolCalendar']);
    }

    ngOnInit() {
        this.isSaving = false;
        this.authorities = ['ROLE_USER', 'ROLE_ADMIN'];
        this.loadSchools();
        this.lessonsAction = UnavailableDateService.DO_NOTHING_WITH_LESSONS_IN_HOLIDAYS;
    }
    clear() {
        this.activeModal.dismiss('cancel');
    }

    save() {
        this.isSaving = true;
        if (this.unavailableDate.id !== undefined) {
            this.unavailableDateService.update(this.unavailableDate, this.lessonsAction)
                .subscribe((res: UnavailableDate) =>
                    this.onSaveSuccess(res), (res: HttpErrorResponse) => this.onSaveError(res));
        } else {
            this.unavailableDateService.create(this.unavailableDate, this.lessonsAction)
                .subscribe((res: UnavailableDate) =>
                    this.onSaveSuccess(res), (res: HttpErrorResponse) => this.onSaveError(res));
        }
    }

    private onSaveSuccess(result: UnavailableDate) {
        this.eventManager.broadcast({ name: 'unavailableDateListModification', content: 'OK' });
        this.isSaving = false;
        this.activeModal.dismiss(result);
    }

    private onSaveError(error) {
        this.isSaving = false;
        this.onError(error);
    }

    trackSchoolById(index: number, item: School) {
        return item.id;
    }

    getSelected(selectedVals: Array<any>, option: any) {
        if (selectedVals) {
            for (let i = 0; i < selectedVals.length; i++) {
                if (option.id === selectedVals[i].id) {
                    return selectedVals[i];
                }
            }
        }
        return option;
    }
}

@Component({
    selector: 'jhi-unavailable-date-popup',
    template: ''
})
export class UnavailableDatePopupComponent implements OnInit, OnDestroy {

    modalRef: NgbModalRef;
    routeSub: any;

    constructor(
        private route: ActivatedRoute,
        private unavailableDatePopupService: UnavailableDatePopupService
    ) { }

    ngOnInit() {
        this.routeSub = this.route.params.subscribe(params => {
            if (params['id']) {
                this.modalRef = this.unavailableDatePopupService
                    .open(UnavailableDateDialogComponent as Component, params['id']);
            } else {
                this.modalRef = this.unavailableDatePopupService
                    .open(UnavailableDateDialogComponent as Component);
            }

        });
    }

    ngOnDestroy() {
        this.routeSub.unsubscribe();
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/unavailable-date/unavailable-date-dialog.component.ts